import { render, staticRenderFns } from "./MegaraxAuthGuard.vue?vue&type=template&id=1f124fd2&"
import script from "./MegaraxAuthGuard.vue?vue&type=script&lang=ts&"
export * from "./MegaraxAuthGuard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports